import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  photoClickDiv: {
    backgroundColor: "transparent",
    display: "block",
    textAlign: "center",
    marginTop: "0px",
    width: "100%",
    height: "100%",
    textDecoration: "none",
  },
  buttonsIcon: {
    background: theme.palette.primary.main,
    marginRight: "7px",
  },
  buttonsIconContainer: {
    bottom: "-15px",
    position: "absolute",
    right: 0,
  },
  cardContent: {
    marginTop: "10px",
  },
  emphase: {
    color: theme.palette.emphase,
  },
  fab: {
    bottom: "50%",
    left: "calc(100% - 30px)",
  },
  icons: {
    color: "white",
    fontSize: "1.5em",
  },
  imageInformation: {
    visibility: "hidden",
  },
  legend: {
    background: "rgba(0,0,0,0.4)",
    color: "#fff",
    marginTop: "-50px",
    position: "relative",
    textAlign: "center",
    width: "100%",
  },
  nbPhotos: {
    color: "#fff",
    position: "absolute",
    right: 10,
    textAlign: "center",
    top: -140,
    width: "25%",
  },
  root: {
    "&:hover": {
      boxShadow:
        "0px 3px 3px 0px rgba(0,0,0,0.34), 0px 1px 1px -1px rgba(0,0,0,0.1)",
    },
    "&:hover $imageInformation": {
      alignItems: "center",
      background: "#00000053",
      color: "white",
      display: "flex",
      height: "100%",
      justifyContent: "center",
      visibility: "inherit",
    },
    cursor: ({ isClickable }) => (isClickable ? "pointer" : "auto"),
    position: "relative",
    width: "100%",
  },
  rootDisabled: {
    opacity: 0.5,
    "&:hover": {
      boxShadow:
        "0px 3px 3px 0px rgba(0,0,0,0.34), 0px 1px 1px -1px rgba(0,0,0,0.1)",
    },
    "&:hover $imageInformation": {
      alignItems: "center",
      background: "#00000053",
      color: "white",
      display: "flex",
      height: "100%",
      justifyContent: "center",
      visibility: "inherit",
    },
    cursor: ({ isClickable }) => (isClickable ? "pointer" : "auto"),
    position: "relative",
    width: "100%",
  },
  separator: {
    borderColor: theme.palette.greyLight,
    margin: "auto",
    opacity: "50%",
    width: "90%",
  },
  texte: {
    height: "30px",
    marginBottom: "10px",
    marginTop: "10px",
    overflow: "hidden",
  },
  typeBienVille: {
    fontSize: "1rem",
  },
  bookmarkIcon: {
    position: "absolute",
    top: -3,
    right: 50,
    color: theme.palette.tonique,
  },
  tagItem: {
    paddingRight: "5px",
  },
}));
